// @ts-strict-ignore
import {Component, Input, viewChild, output} from "@angular/core";
import {Translations} from "@translations";
import {MatDrawer, MatDrawerMode} from "@angular/material/sidenav";
import {FontAwesomeCode} from "@models";

@Component({
	selector: "sim-drawer-form-field",
	templateUrl: "./drawer-form-field.component.html",
	styleUrl: "./drawer-form-field.component.scss",
	standalone: false,
})
export class DrawerFormFieldComponent {
	// I/O
	@Input() mode: MatDrawerMode = "side";
	@Input() position: "start" | "end" = "end";
	@Input() icon: FontAwesomeCode;
	@Input() iconBadge: string | null = null;
	onToggle = output<boolean>();

	public drawer = viewChild.required<MatDrawer>("drawer");

	// Readonly
	protected readonly T = Translations;

	public close = () => this.drawer().close();

	public toggle(): void {
		this.onToggle.emit(!this.drawer().opened);
		this.drawer().toggle().then();
	}
}
